// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"797c7af6","453":"849bb9cb","732":"928edd42"}[chunkId] + ".chunk.js";
};